export interface BuildingDimensions {
  width: number;
  length: number;
  height: number;
  // Optional roof slope in degrees; if undefined, roof defaults are used per type
  roofAngleDeg?: number;
}

export interface BuildingProperties {
  id: string;
  name: string;
  type: BuildingType;
  dimensions: BuildingDimensions;
  position: {
    x: number;
    y: number;
    z: number;
  };
  rotation: number;
  color: string;
  roofType: RoofType;
  compliance: ComplianceStatus;
  createdAt: string;
  updatedAt: string;
}

export enum BuildingType {
  RESIDENTIAL = "residential",
  COMMERCIAL = "commercial",
  INDUSTRIAL = "industrial",
  OFFICE = "office",
  WAREHOUSE = "warehouse",
}

export enum RoofType {
  FLAT = "flat", // Flachdach
  GABLE = "gable", // Satteldach
  HIP = "hip", // Walmdach
  SHED = "shed", // Pultdach
  DORMER = "dormer", // Schleppdach
  MANSARD = "mansard", // Mansarddach
  ROUND = "round", // Runddach
}

export enum ComplianceStatus {
  COMPLIANT = "compliant", // Green
  NON_COMPLIANT = "non_compliant", // Red
  WARNING = "warning", // Yellow
  UNKNOWN = "unknown", // Gray
}
